import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/PageLayout/index.ts";
export const data = {
  title: "Privacy Policy",
  subtitle: ""
};
export const _frontmatter = {};
const layoutProps = {
  data,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Data privacy policy`}</h2>
    <p>{`Cheuk Lee is committed to take all reasonable steps to preserve the confidentiality of all Personal Information it
collects in a manner consistent with applicable law.`}</p>
    <p>{`This Privacy Policy is to provide details on how Cheuk Lee collects, uses information of visitors to the website. `}</p>
    <h2>{`Collection of information`}</h2>
    <p>{`Google analytics will be used.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      